export default __webpack_public_path__ + "static/0127-5f9fc77ed45a81a3db3f2a53bd80638e.png";